module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./BusinessSpaceConfigView.jsx"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&nam/*  */e=BusinessSpaceConfig!./src/pages/bundle-appResource-mgmt/BusinessSpaceConfig/BusinessSpaceConfigView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&nam/*  */e=BusinessSpaceConfig!./src/pages/bundle-appResource-mgmt/BusinessSpaceConfig/BusinessSpaceConfigView.jsx
// module chunks = 43